import React, { useState, useEffect } from 'react';

const VIDEO_URL = 'https://customer-assets.emergentagent.com/job_tempo-run-1/artifacts/ps7a999t_Martin_s%20Video%20-%20Mar%2018%2C%202026%20%283%29.mp4';
const POSTER_URL = 'https://customer-assets.emergentagent.com/job_d9fbb34d-e9c4-482e-afdb-805cbbe7f33f/artifacts/gkpxyg3g_IMG_3440.PNG';

export default function PhoneMockVideo({ className = '' }) {
  const [phase, setPhase] = useState('video');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('animating'), 2000);
    const t2 = setTimeout(() => setPhase('done'), 3600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const show = phase === 'animating' || phase === 'done';

  return (
    <div className={`relative mx-auto w-[220px] h-[450px] sm:w-[260px] sm:h-[530px] lg:w-[280px] lg:h-[570px] ${className}`} data-testid="landing-hero-phone-video">
      {/* Phone frame */}
      <div className="relative w-full h-full rounded-[32px] sm:rounded-[36px] lg:rounded-[40px] bg-black border-[2.5px] sm:border-[3px] border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.8),0_0_0_1px_rgba(255,255,255,0.05)] overflow-hidden">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[90px] sm:w-[110px] lg:w-[120px] h-[22px] sm:h-[26px] lg:h-[28px] bg-black rounded-b-[12px] z-30" />
        
        {/* Video background */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={VIDEO_URL}
          poster={POSTER_URL}
          autoPlay
          muted
          loop
          playsInline
        />
        
        {/* Poster fallback */}
        <img src={POSTER_URL} alt="" className="absolute inset-0 w-full h-full object-cover -z-[1]" />

        {/* Dark base overlay */}
        <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.15)' }} />

        {/* Gradient overlay */}
        <div 
          className="absolute inset-0 z-10"
          style={{ 
            background: 'linear-gradient(to bottom, transparent 0%, rgba(5,5,5,0.2) 20%, rgba(5,5,5,0.65) 50%, rgba(5,5,5,0.92) 72%, #050505 92%)',
            opacity: show ? 1 : 0,
            transition: 'opacity 1400ms ease-out'
          }}
        />

        {/* Content - bottom aligned */}
        <div className="absolute inset-0 z-20 flex flex-col justify-end px-3 sm:px-4 lg:px-[18px] pb-5 sm:pb-6 lg:pb-7">
          
          {/* TEMPO logo */}
          <h2 
            style={{ 
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 700,
              color: '#CCFF00',
              opacity: show ? 1 : 0,
              transform: show ? 'translateY(0px)' : 'translateY(14px)',
              transition: 'opacity 800ms ease-out 300ms, transform 800ms ease-out 300ms'
            }}
            className="text-[40px] sm:text-[48px] lg:text-[52px] leading-[44px] sm:leading-[52px] lg:leading-[56px] tracking-[6px] sm:tracking-[8px] lg:tracking-[9px]"
          >
            TEMPO
          </h2>

          {/* Tagline row */}
          <div 
            className="flex items-center gap-2 mt-1"
            style={{ 
              opacity: show ? 1 : 0,
              transition: 'opacity 700ms ease-out 500ms'
            }}
          >
            <div className="w-4 sm:w-5 h-[1.5px] sm:h-[2px] bg-[#CCFF00] opacity-70" />
            <span className="text-[6px] sm:text-[7px] lg:text-[7.5px] font-semibold text-white/50 tracking-[2.5px] sm:tracking-[3px] lg:tracking-[3.5px] uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
              YOUR RUNNING COACH
            </span>
          </div>

          {/* Description */}
          <p 
            className="mt-2.5 sm:mt-3 text-[9px] sm:text-[10px] lg:text-[10.5px] leading-[14px] sm:leading-[15px] lg:leading-[16px]"
            style={{ 
              fontFamily: "'Inter', sans-serif",
              color: 'rgba(255,255,255,0.55)',
              opacity: show ? 1 : 0,
              transition: 'opacity 700ms ease-out 700ms'
            }}
          >
            AI-powered coaching that adapts<br />
            to you. Train smarter. Run stronger.
          </p>

          {/* CTA block */}
          <div 
            className="mt-4 sm:mt-5"
            style={{ 
              opacity: show ? 1 : 0,
              transform: show ? 'translateY(0px)' : 'translateY(18px)',
              transition: 'opacity 600ms ease-out 900ms, transform 600ms ease-out 900ms'
            }}
          >
            <div className="bg-[#CCFF00] rounded-[9px] sm:rounded-[10px] lg:rounded-[11px] py-2.5 sm:py-3 text-center">
              <span className="text-[10px] sm:text-[11px] lg:text-[12.5px] font-bold text-black tracking-[2px] sm:tracking-[2.5px] lg:tracking-[3px] uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                GET STARTED
              </span>
            </div>
            <p className="text-center mt-2 text-[7px] sm:text-[8px] lg:text-[8.5px] text-white/40" style={{ fontFamily: "'Inter', sans-serif" }}>
              Already have an account?{' '}
              <span className="font-semibold text-[#CCFF00]">Log in</span>
            </p>
          </div>
        </div>

        {/* Bottom home bar */}
        <div className="absolute bottom-1 sm:bottom-1.5 left-1/2 -translate-x-1/2 w-[60px] sm:w-[70px] lg:w-[80px] h-[2.5px] sm:h-[3px] bg-white/30 rounded-full z-30" />
      </div>
      
      {/* Glow */}
      <div className="absolute -inset-6 sm:-inset-8 rounded-[50px] sm:rounded-[60px] bg-[#CCFF00]/5 blur-3xl -z-10" />
    </div>
  );
}
